export default "__VITE_ASSET__aW2R7x3g__"